import React from "react";

const viewBox = "0 0 64 64";

/** Custom inline SVG artwork per category (no external assets). */
const CategoryIconArt = ({ categoryName, size = 40 }) => {
  const common = {
    width: size,
    height: size,
    viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true,
  };

  switch (categoryName) {
    case "All":
      return (
        <svg {...common}>
          <rect x="8" y="8" width="20" height="20" rx="5" fill="white" fillOpacity="0.95" />
          <rect x="36" y="8" width="20" height="20" rx="5" fill="white" fillOpacity="0.75" />
          <rect x="8" y="36" width="20" height="20" rx="5" fill="white" fillOpacity="0.75" />
          <rect x="36" y="36" width="20" height="20" rx="5" fill="white" fillOpacity="0.95" />
        </svg>
      );
    case "Electronics":
      return (
        <svg {...common}>
          <rect x="12" y="16" width="40" height="28" rx="4" fill="white" fillOpacity="0.9" />
          <rect x="16" y="20" width="32" height="18" rx="2" fill="#002366" fillOpacity="0.35" />
          <path d="M24 48h16" stroke="white" strokeWidth="3" strokeLinecap="round" />
          <circle cx="46" cy="14" r="6" fill="#ffeb3b" />
        </svg>
      );
    case "Clothing":
      return (
        <svg {...common}>
          <path
            d="M32 12l8 6 12-4-4 14H16l-4-14 12 4 8-6z"
            fill="white"
            fillOpacity="0.95"
          />
          <path d="M22 28v22h20V28" stroke="white" strokeWidth="2.5" strokeLinejoin="round" />
        </svg>
      );
    case "Home & Garden":
      return (
        <svg {...common}>
          <path d="M10 30L32 14l22 16v18H10V30z" fill="white" fillOpacity="0.92" />
          <rect x="26" y="34" width="12" height="14" rx="1" fill="#43a047" fillOpacity="0.5" />
          <circle cx="48" cy="22" r="8" fill="#ffca28" />
        </svg>
      );
    case "Sports & Outdoors":
      return (
        <svg {...common}>
          <circle cx="32" cy="32" r="18" stroke="white" strokeWidth="3" />
          <path
            d="M18 32c6-10 22-10 28 0M18 32c6 10 22 10 28 0M32 14v36"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      );
    case "Books & Media":
      return (
        <svg {...common}>
          <path d="M14 14h16v36H14V14z" fill="white" fillOpacity="0.9" />
          <path d="M30 18h20v32H30V18z" fill="white" fillOpacity="0.65" />
          <path d="M18 22h8M18 28h8M34 26h12M34 32h12" stroke="#5e35b1" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case "Health & Beauty":
      return (
        <svg {...common}>
          <ellipse cx="32" cy="38" rx="14" ry="18" fill="white" fillOpacity="0.9" />
          <rect x="26" y="10" width="12" height="14" rx="3" fill="white" />
          <circle cx="32" cy="36" r="4" fill="#ec407a" fillOpacity="0.6" />
        </svg>
      );
    case "Toys & Games":
      return (
        <svg {...common}>
          <rect x="14" y="22" width="36" height="22" rx="6" fill="white" fillOpacity="0.9" />
          <circle cx="24" cy="33" r="4" fill="#001A4D" />
          <circle cx="40" cy="33" r="4" fill="#0072CE" />
          <path d="M20 18h24l-4-8H24l-4 8z" fill="white" fillOpacity="0.85" />
        </svg>
      );
    case "Ticket Booking":
    case "Automotive":
      return (
        <svg {...common}>
          <path
            d="M14 20h36a4 4 0 014 4v4a6 6 0 00-6 6 6 6 0 006 6v4a4 4 0 01-4 4H14a4 4 0 01-4-4v-4a6 6 0 016-6 6 6 0 01-6-6v-4a4 4 0 014-4z"
            fill="white"
            fillOpacity="0.92"
          />
          <path
            d="M28 20v28"
            stroke="rgba(30,136,229,0.55)"
            strokeWidth="2"
            strokeDasharray="3 3"
          />
          <circle cx="21" cy="28" r="2" fill="#002366" />
          <circle cx="21" cy="36" r="2" fill="#002366" />
        </svg>
      );
    case "Food & Beverages":
      return (
        <svg {...common}>
          <path d="M20 18h24v28c0 4-4 8-12 8s-12-4-12-8V18z" fill="white" fillOpacity="0.9" />
          <ellipse cx="32" cy="18" rx="12" ry="4" fill="white" />
          <path d="M26 28h12M26 36h12" stroke="#f57c00" strokeWidth="2.5" strokeLinecap="round" />
          <circle cx="44" cy="24" r="5" fill="#8bc34a" />
        </svg>
      );
    case "Jewelry & Accessories":
      return (
        <svg {...common}>
          <path
            d="M32 48L18 26h28L32 48z"
            fill="white"
            fillOpacity="0.9"
            stroke="white"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <circle cx="32" cy="22" r="8" fill="#ffd54f" />
          <path d="M32 14v-4M32 54v-2" stroke="white" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case "Baby & Kids":
      return (
        <svg {...common}>
          <circle cx="32" cy="24" r="10" fill="white" fillOpacity="0.95" />
          <path d="M16 52c4-12 28-12 32 0" fill="white" fillOpacity="0.85" />
          <circle cx="28" cy="22" r="1.5" fill="#5c6bc0" />
          <circle cx="36" cy="22" r="1.5" fill="#5c6bc0" />
          <path d="M28 28q4 4 8 0" stroke="#5c6bc0" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      );
    case "Pet Supplies":
      return (
        <svg {...common}>
          <ellipse cx="32" cy="36" rx="16" ry="14" fill="white" fillOpacity="0.9" />
          <circle cx="20" cy="22" r="6" fill="white" fillOpacity="0.85" />
          <circle cx="44" cy="22" r="6" fill="white" fillOpacity="0.85" />
          <circle cx="14" cy="32" r="5" fill="white" fillOpacity="0.75" />
          <circle cx="50" cy="32" r="5" fill="white" fillOpacity="0.75" />
          <circle cx="28" cy="36" r="2" fill="#5d4037" />
          <circle cx="36" cy="36" r="2" fill="#5d4037" />
        </svg>
      );
    case "Industrial & Scientific":
      return (
        <svg {...common}>
          <path d="M18 46V22l14-8 14 8v24H18z" fill="white" fillOpacity="0.88" />
          <path d="M26 46V30h12v16" stroke="#3949ab" strokeWidth="2" />
          <circle cx="32" cy="18" r="4" fill="#3949ab" fillOpacity="0.5" />
        </svg>
      );
    case "Arts & Crafts":
      return (
        <svg {...common}>
          <path d="M14 46l18-28 18 28H14z" fill="white" fillOpacity="0.85" />
          <circle cx="22" cy="20" r="5" fill="#0B1C48" />
          <circle cx="32" cy="16" r="5" fill="#fdd835" />
          <circle cx="42" cy="20" r="5" fill="#002366" />
          <rect x="28" y="34" width="8" height="12" fill="#8d6e63" />
        </svg>
      );
    case "Office Supplies":
      return (
        <svg {...common}>
          <rect x="14" y="18" width="36" height="26" rx="3" fill="white" fillOpacity="0.9" />
          <path d="M14 26h36" stroke="#0B1C48" strokeWidth="2" />
          <rect x="20" y="32" width="14" height="3" rx="1" fill="#0B1C48" fillOpacity="0.4" />
          <rect x="20" y="38" width="22" height="3" rx="1" fill="#0B1C48" fillOpacity="0.25" />
          <path d="M38 12v8" stroke="white" strokeWidth="3" strokeLinecap="round" />
        </svg>
      );
    case "Musical Instruments":
      return (
        <svg {...common}>
          <ellipse cx="24" cy="40" rx="14" ry="16" fill="white" fillOpacity="0.9" />
          <rect x="36" y="12" width="6" height="36" rx="2" fill="white" />
          <path d="M42 12c8 4 8 16 0 20" stroke="white" strokeWidth="3" strokeLinecap="round" />
          <circle cx="24" cy="40" r="5" fill="#6a1b9a" fillOpacity="0.35" />
        </svg>
      );
    case "Tools & Hardware":
      return (
        <svg {...common}>
          <path
            d="M38 14l12 12-8 8-6-6-10 10-8-8 10-10-6-6 8-8z"
            fill="white"
            fillOpacity="0.92"
          />
          <rect x="12" y="44" width="28" height="6" rx="2" fill="white" fillOpacity="0.7" />
        </svg>
      );
    case "Furniture":
      return (
        <svg {...common}>
          <rect x="14" y="28" width="36" height="14" rx="4" fill="white" fillOpacity="0.9" />
          <rect x="18" y="42" width="4" height="10" fill="white" fillOpacity="0.8" />
          <rect x="42" y="42" width="4" height="10" fill="white" fillOpacity="0.8" />
          <rect x="20" y="18" width="24" height="10" rx="3" fill="white" fillOpacity="0.75" />
        </svg>
      );
    case "Kitchen & Dining":
      return (
        <svg {...common}>
          <ellipse cx="32" cy="36" rx="18" ry="10" fill="white" fillOpacity="0.9" />
          <path d="M14 36h36" stroke="#ef6c00" strokeWidth="2" />
          <path d="M32 14v14" stroke="white" strokeWidth="3" strokeLinecap="round" />
          <circle cx="32" cy="12" r="4" fill="white" />
        </svg>
      );
    case "Personal Care":
      return (
        <svg {...common}>
          <rect x="24" y="10" width="16" height="36" rx="6" fill="white" fillOpacity="0.9" />
          <rect x="28" y="14" width="8" height="10" rx="2" fill="#26a69a" fillOpacity="0.45" />
          <ellipse cx="32" cy="50" rx="10" ry="4" fill="white" fillOpacity="0.6" />
        </svg>
      );
    case "Other":
      return (
        <svg {...common}>
          <circle cx="32" cy="32" r="20" stroke="white" strokeWidth="3" strokeDasharray="6 4" />
          <text
            x="32"
            y="37"
            textAnchor="middle"
            fill="white"
            fontSize="18"
            fontWeight="bold"
            fontFamily="system-ui, sans-serif"
          >
            +
          </text>
        </svg>
      );
    default:
      return (
        <svg {...common}>
          <circle cx="32" cy="32" r="18" fill="white" fillOpacity="0.85" />
        </svg>
      );
  }
};

export default CategoryIconArt;
